export default "assets/images/gray-dark-texture-68ef288b.png";